export const SHOP_LIST = 'SHOP_LIST'
export const SHOP_DETAIL = 'SHOP_DETAIL'
export const CART_LIST = 'CART_LIST'
export const CART_STEP = 'CART_STEP'
export const ORDER_DATA = 'ORDER_DATA'